import {
  ACCESS_REMOVED_MESSAGE,
  getErrorStatus,
} from './jobAccessError';
import { getMutationErrorMessage } from './mutationErrorMessage';

const DOWNLOAD_FALLBACK =
  'We could not download this applicant file. Please try again.';

export const getApplicantFileErrorMessage = (error: unknown): string => {
  const status = getErrorStatus(error);

  if (status === 403) return ACCESS_REMOVED_MESSAGE;
  if (status === 404) return 'This applicant file could not be found.';
  if (status === 410) {
    return getMutationErrorMessage(
      error,
      "This applicant's resume has expired.",
    );
  }
  if (status === 503) {
    return getMutationErrorMessage(
      error,
      'This applicant file is temporarily unavailable. Please try again.',
    );
  }

  return getMutationErrorMessage(error, DOWNLOAD_FALLBACK);
};
